/* eslint-disable @typescript-eslint/require-await */
import { DIDStorage } from '@cp/shared/deviceId';

export class BrowserDeviceIDStorage implements DIDStorage {
  readonly #storage: Storage;
  readonly #key: string;
  constructor(browserStorage: Storage, key = 'did') {
    this.#storage = browserStorage;
    this.#key = key;
  }
  async get() {
    return this.#storage.getItem(this.#key) || undefined;
  }
  async set(value: string) {
    this.#storage.setItem(this.#key, value);
  }
}
